<ul class="dashboard-nav-list">
  @for (item of items(); track item.label) {
    @if ('children' in item) {
      <ng-container [ngTemplateOutlet]="groupTemplate" [ngTemplateOutletContext]="{ $implicit: item }" />
    } @else {
      <ng-container [ngTemplateOutlet]="linkTemplate" [ngTemplateOutletContext]="{ $implicit: item }" />
    }
  }
</ul>

@if (hasBetaItem()) {
  <p class="beta-note">
    Beta features: feedback welcome at
    <a class="beta-note-link" [href]="'mailto:' + feedbackEmail" (click)="itemClick.emit($event)">{{
      feedbackEmail
    }}</a>
  </p>
}

<ng-template #groupTemplate let-group>
  <li class="group-header">{{ group.label }}</li>

  @for (child of group.children; track child.routerLink) {
    <ng-container [ngTemplateOutlet]="linkTemplate" [ngTemplateOutletContext]="{ $implicit: child }" />
  }
</ng-template>

<ng-template #linkTemplate let-link>
  <li class="list-item">
    <a
      atButton
      class="list-item-link"
      routerLinkActive="active"
      size="sm"
      variant="plain"
      [routerLink]="link.routerLink"
      (click)="itemClick.emit($event)"
    >
      <at-icon>{{ link.icon }}</at-icon>
      <!-- A Beta item wraps its label so the pill sits under it, not at the row's end where the count goes. -->
      @if (isBeta(link)) {
        <span class="list-item-text">
          {{ link.label }}
          <span class="nav-beta">Beta</span>
        </span>
      } @else {
        {{ link.label }}
      }
      @if (link.badge && link.badge() > 0) {
        <span class="nav-badge sa-mono" [attr.aria-label]="link.badge() + ' unread'">{{ link.badge() }}</span>
      } @else if (link.live && link.live()) {
        <span aria-label="Sweeping now" class="nav-live"></span>
      } @else if (link.chip) {
        <span class="nav-chip">{{ link.chip }}</span>
      }
    </a>
  </li>
</ng-template>
